export default "/fonts/PublicSans-ExtraBold.ttf?37b90e7877cafd679cc251f40229e9a2";